<script>
import { mapState, mapGetters, mapActions } from "vuex";
import NewCity from "./NewCity";
import NewState from "./NewState";
import NewDistrict from "./NewDistrict";
import Pagination from "@/components/_Shared/Pagination";
import PreloaderTable from "@/components/_Shared/PreloaderTable";
import numberMixin from "@/mixins/numberMixin";
import dateMixin from "@/mixins/dateMixin";

export default {
  title: "Cidades",
  mixins: [numberMixin, dateMixin],
  data() {
    return {
      newCity: false,
      newState: false,
      newDistrict: false,
      districts: [],
      search: ""
    };
  },

  components: {
    NewCity,
    NewState,
    NewDistrict,
    Pagination,
    PreloaderTable
  },

  computed: {
    ...mapState("cities", [
      "list",
      "preloader",
      "pagination",
      "selected",
      "text_search"
    ])
  },

  methods: {
    ...mapActions("cities", [
      "listAll",
      "setCurrentPage",
      "setSelectedCity",
      "setTextSearch"
    ]),
    showNewDistrict(event) {
      this.newDistrict = true;
      event.stopPropagation();
    },
    input(value) {
      this.setCurrentPage(value);
    }
  },

  mounted() {
    if (!this.list || !this.list.length) this.listAll();
  }
};
</script>

<template>
  <div class="box">
    <div class="title">CIDADES</div>

    <div class="buttons-filters">
      <div>
        <div class="new-group" @click="newCity = !newCity">
          <img src="../../../static/plus.svg" /> Cadastrar nova cidade
        </div>
        <div class="new-group" @click="newState = !newState">
          <img src="../../../static/plus.svg" /> Cadastrar novo estado
        </div>
      </div>

      <v-layout align-center justify-end row fill-height wrap>
        <input
          type="text"
          v-model="search"
          @keyup.enter="setTextSearch(search)"
          placeholder="buscar"
          class="with-icon icon-search sm text-lowercase"
        />
        <v-btn
          small
          class="primary text-lowercase"
          @click="setTextSearch(search)"
        >
          <span>buscar</span>
        </v-btn>
      </v-layout>
    </div>

    <transition name="fade" mode="out-in">
      <PreloaderTable v-if="preloader" />

      <div key="1" v-else class="table">
        <table>
          <thead>
            <tr>
              <th>Cidade</th>
              <th>Estado</th>
              <th>País</th>
              <th>Distritos</th>
            </tr>
          </thead>

          <tbody>
            <template v-for="city in list">
              <tr
                class="pointer"
                :key="city.id"
                @click="setSelectedCity(city.id)"
              >
                <td>{{ city.display_name }}</td>
                <td>{{ city.state.code.toUpperCase() }}</td>
                <td>{{ city.state.country.code.toUpperCase() }}</td>
                <td>{{ city.districts.length }}</td>
                <td nowrap class="buttons">
                  <div
                    v-if="selected.id === city.id"
                    class="btn btn-small bg-purple-outline float-right"
                    @click="showNewDistrict"
                  >
                    adicionar distrito
                  </div>
                </td>
              </tr>

              <tr
                v-if="selected.id == city.id && selected.districts.length"
                class="nested-table"
                :key="city.id + '-nested'"
              >
                <td colspan="5">
                  <table>
                    <thead>
                      <th>Distrito</th>
                      <th>Taxa</th>
                      <th>Taxa por Hora</th>
                      <th>Preço</th>
                      <th>Preço por Hora</th>
                      <th>Nota Mínima</th>
                      <th>Nota Máxima</th>
                      <th>Atualizado em</th>
                      <th></th>
                    </thead>

                    <tbody>
                      <tr
                        v-for="district in selected.districts"
                        :key="district.id"
                      >
                        <td>{{ district.display_name }}</td>
                        <td>{{ district.pricing.fee | intToCurrency }}</td>
                        <td>
                          {{ district.pricing.fee_per_hour | intToCurrency }}
                        </td>
                        <td>{{ district.pricing.price | intToCurrency }}</td>
                        <td>
                          {{ district.pricing.price_per_hour | intToCurrency }}
                        </td>
                        <td>
                          {{ district.rating.rating_min | intToDecimal }}%
                        </td>
                        <td>
                          {{ district.rating.rating_max | intToDecimal }}%
                        </td>
                        <td>
                          {{
                            [
                              district.updated_at,
                              district.rating.updated_at,
                              district.pricing.updated_at
                            ]
                              | greaterDate
                              | formatDate
                          }}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </template>
          </tbody>
        </table>

        <div class="text-xs-center pt-2">
          <v-pagination
            v-model="pagination.current"
            :total-visible="7"
            :length="pagination.totalPages"
            @input="input"
            circle
          ></v-pagination>
        </div>
      </div>
    </transition>

    <NewCity v-if="newCity" @close="newCity = false" @refresh="listAll()" />
    <NewDistrict
      v-if="newDistrict"
      @close="newDistrict = false"
      :city_id="selected.id"
      @refresh="listAll()"
    />
    <NewState v-if="newState" @close="newState = false" />
  </div>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Cities/Index.vue